/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallForOpportunity } from '../../models/call-for-opportunity';
import { CallForOpportunityMatches } from '../../models/call-for-opportunity-matches';

export interface GetCallForOpportunity$Params {
  id: string;
}

export function getCallForOpportunity(http: HttpClient, rootUrl: string, params: GetCallForOpportunity$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<(CallForOpportunity | CallForOpportunityMatches)>>> {
  const rb = new RequestBuilder(rootUrl, getCallForOpportunity.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<(CallForOpportunity | CallForOpportunityMatches)>>;
    })
  );
}

getCallForOpportunity.PATH = '/callforopportunity/{id}';
